define('blocks/popup/popup',['require'],function(require) {
    var $popupSuccess = $('#popup-succes');
    var $popupError = $('#popup-error');

    $popupSuccess.add($popupError).on('click', '[data-action=close]', function(event) {
        event.preventDefault();
        $popupSuccess.hide();
        $popupError.hide();
    });
})
;
